import { MESSAGES_SERVICE } from "@/services/messages.service.js";

const state = {postMessagesOutput: false};

const actions = {
    //Service to send messages
    postMessages({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postMessagesRequest');

        MESSAGES_SERVICE.postMessages(input)
            .then(
                output => {
                    commit('postMessagesSuccess', output);
                },
                error => {
                    commit('postMessagesFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postMessages
    postMessagesRequest(state) {
        state.postMessagesOutput = null;
    },
    postMessagesSuccess(state, output) {
        state.postMessagesOutput = true;
    },
    postMessagesFailure(state) {
        state.postMessagesOutput = false;
    },
};

export const messages = {
    namespaced: true,
    state,
    actions,
    mutations
};